import { twMerge } from 'tailwind-merge';

import { TONE_DOT, type StatusTone } from '~/components/ui/status-chip/tones';

interface StatusChipProps {
  label: string;
  tone: StatusTone;
  dot?: boolean;
  testId?: string;
  className?: string;
}

const SURFACE: Record<StatusTone, string> = {
  success: 'bg-success-50 text-success-700 dark:bg-success-500/15 dark:text-success-500',
  warning: 'bg-warning-50 text-warning-700 dark:bg-warning-500/15 dark:text-warning-400',
  error: 'bg-error-50 text-error-700 dark:bg-error-500/15 dark:text-error-500',
  info: 'bg-blue-light-50 text-blue-light-700 dark:bg-blue-light-500/15 dark:text-blue-light-500',
  neutral: 'bg-gray-100 text-gray-700 dark:bg-white/5 dark:text-white/80',
  brand: 'bg-brand-50 text-brand-600 dark:bg-brand-500/15 dark:text-brand-400',
  draft: 'bg-theme-purple-500/10 text-theme-purple-500 dark:bg-theme-purple-500/15',
};

/** A live state (Active, Failed, Scheduled). Tone is semantic; each feature owns its status-to-tone map. */
export function StatusChip({ label, tone, dot = false, testId, className }: StatusChipProps) {
  return (
    <span
      data-testid={testId}
      className={twMerge(
        'inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium',
        SURFACE[tone],
        className,
      )}
    >
      {dot && (
        <span aria-hidden="true" className={`size-2 shrink-0 rounded-full ${TONE_DOT[tone]}`} />
      )}
      {label}
    </span>
  );
}
